export enum FilterEnums {
  General = 'general',
  Geographic = 'geographic',
  Amount = 'amount',
  Radius = 'radius',
}